import { Route } from "@faire/web-api/Route";
import { props as privacyRouteProps } from "@faire/web-api/routes/privacy";
import { props as privacyCookiesRouteProps } from "@faire/web-api/routes/privacy/cookies";
import { Switch } from "@faire/web/ui/routing/Switch";
import React from "react";

import { RetailerStore } from "@faire/retailer/stores/domain/RetailerStore";
import { LazyCookiePolicy } from "@faire/retailer/views/privacy/cookie/LazyCookiePolicy";
import { LazyAUSPrivacyPolicy } from "@faire/retailer/views/privacy/LazyAUSPrivacyPolicy";
import { LazyPrivacyPolicy } from "@faire/retailer/views/privacy/LazyPrivacyPolicy";

export const PrivacyRouter = () => (
  <Switch>
    <Route
      {...privacyRouteProps}
      component={
        RetailerStore.get().isAustralian
          ? LazyAUSPrivacyPolicy
          : LazyPrivacyPolicy
      }
      exact
    />
    <Route {...privacyCookiesRouteProps} component={LazyCookiePolicy} exact />
  </Switch>
);
